export type NavItem = {
  label: string
  href: string
  description: string
  badge?: string
  /** Shown indented beneath the previous item. */
  nested?: boolean
}

export type NavGroup = { heading?: string; items: NavItem[] }

export type NavMenu = {
  label: string
  /** Direct link (no dropdown) when set. */
  href?: string
  groups?: NavGroup[]
  width?: string
  align?: 'left' | 'right'
}

export const mainMenu: NavMenu[] = [
  {
    label: 'Solutions',
    width: 'w-96',
    groups: [
      {
        items: [
          {
            label: 'Solutions Overview',
            href: '/solutions',
            description: 'How SyNeural is used in research, education, work & government',
          },
          {
            label: 'SKP — Connected Knowledge',
            href: '/semantic-knowledge',
            description: 'Connect, organize, and govern knowledge across research and organizational systems.',
          },
          {
            label: 'Noetivra — Interactive Dashboard',
            href: '/noetivra',
            description:
              'Explore connected knowledge, conduct assessments, review findings, and operate SyNeural’s underlying systems through one intuitive interface.',
          },
          {
            label: 'Demo Center',
            href: '/noetivra/demo-center',
            description: 'Working demos across seven domains',
            nested: true,
          },
        ],
      },
    ],
  },
  { label: 'Human Capability Framework', href: '/human-capability' },
  { label: 'Projects', href: '/projects' },
  {
    label: 'Research',
    width: 'w-80',
    groups: [
      {
        items: [
          {
            label: 'Research Overview',
            href: '/research',
            description: 'Assessment methods, evidence & supporting concepts',
          },
          {
            label: 'Papers & Publications',
            href: '/roadmap#publications',
            description: 'White papers, concept notes & research directions',
          },
          {
            label: 'Roadmap',
            href: '/roadmap',
            description: 'Product development & planned capabilities',
          },
        ],
      },
    ],
  },
  {
    label: 'About',
    width: 'w-72',
    align: 'right',
    groups: [
      {
        items: [
          { label: 'About SyNeural', href: '/about', description: 'Our mission, vision & leadership' },
          { label: 'Partnerships', href: '/partnerships', description: 'Work with us on pilots and research' },
          { label: 'Investors', href: '/investors', description: 'The opportunity & business model' },
        ],
      },
    ],
  },
]

import { pillarHref, pillars } from './pillars'

export type FooterLink = { label: string; href: string; nested: boolean; deep?: boolean }

export const footerColumns: { heading: string; links: FooterLink[] }[] = [
  {
    heading: 'Solutions',
    links: [
      { label: 'Solutions Overview', href: '/solutions', nested: false },
      { label: 'SKP — Connected Knowledge', href: '/semantic-knowledge', nested: false },
      { label: 'Noetivra — Interactive Dashboard', href: '/noetivra', nested: false },
      { label: 'Demo Center', href: '/noetivra/demo-center', nested: true },
      { label: 'Education', href: '/education', nested: false },
      { label: 'Employers', href: '/employers', nested: false },
      { label: 'Civil Society', href: '/civil-society', nested: false },
      { label: 'Government', href: '/government', nested: false },
      { label: 'Leadership', href: '/leadership', nested: false },
    ],
  },
  {
    heading: 'Human Capability Framework',
    links: [
      { label: 'Human Capability Framework', href: '/human-capability', nested: false },
      { label: 'CJI', href: '/cji', nested: true },
      { label: 'NCJI', href: '/ncji', nested: true },
      ...pillars.map((pillar) => ({
        label: pillar.shortLabel,
        href: pillarHref(pillar.id),
        nested: false,
        deep: true,
      })),
    ],
  },
  {
    heading: 'Projects',
    links: [
      { label: 'All Projects', href: '/projects', nested: false },
      { label: 'Cognocracy', href: '/projects/cognocracy', nested: true },
    ],
  },
  {
    heading: 'Research',
    links: [
      { label: 'Research Overview', href: '/research', nested: false },
      { label: 'Papers & Publications', href: '/roadmap#publications', nested: false },
      { label: 'Roadmap', href: '/roadmap', nested: false },
    ],
  },
  {
    heading: 'About',
    links: [
      { label: 'About SyNeural', href: '/about', nested: false },
      { label: 'Partnerships', href: '/partnerships', nested: false },
      { label: 'Investors', href: '/investors', nested: false },
      { label: 'Contact Us', href: '/contact', nested: false },
    ],
  },
]
